import axios from "axios";
import Head from "next/head";
import { Footer, Header } from "@/components/sultanhorse-ui";
import { useTranslation } from "next-i18next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";

const BlogDetail = ({ dataBlogs }) => {
  const { t } = useTranslation();
  return (
    <>
      <Head>
        <meta charSet="UTF-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta
          name="description"
          content={`${dataBlogs.title?.rendered} - Sultan Horse menawarkan layanan rental terbaik di kawasan ini, dengan tambahan jasa shuttle, pengiriman barang, serta layanan topup dan tagihan. Kemudahan dan kepercayaan adalah prioritas kami.`}
        />
        <meta
          name="keywords"
          content="rental mobil, jasa shuttle, pengiriman barang, layanan topup, layanan tagihan, kepercayaan, kemudahan, rental berkualitas, Sultan Horse"
        />
        <meta name="author" content="Sultan Horse" />
        <meta name="robots" content="index, follow" />
        <meta
          name="canonical"
          href={`https://sultanhorse.com/blog/${dataBlogs.slug}`}
        />
        <meta
          property="og:title"
          content={`${dataBlogs.title?.rendered} - Sultan Horse`}
        />
        <meta
          property="og:description"
          content={`${dataBlogs.title?.rendered} - Sultan Horse menawarkan layanan rental terbaik di kawasan ini, dengan tambahan jasa shuttle, pengiriman barang, serta layanan topup dan tagihan. Kemudahan dan kepercayaan adalah prioritas kami.`}
        />
        <meta
          property="og:image"
          content={
            dataBlogs.featured_media ||
            "https://sultanhorse.com/images/hero.webp"
          }
        />
        <meta property="og:image:width" content="1080" />
        <meta property="og:image:height" content="1080" />
        <meta property="og:type" content="article" />
        <meta
          property="og:url"
          content={`https://sultanhorse.com/blog/${dataBlogs.slug}`}
        />
        <meta property="og:site_name" content="Sultan Horse" />
        <meta
          name="twitter:title"
          content={`${dataBlogs.title?.rendered} - Sultan Horse`}
        />
        <meta
          name="twitter:description"
          content={`${dataBlogs.title?.rendered} - Sultan Horse menawarkan layanan rental terbaik di kawasan ini, dengan tambahan jasa shuttle, pengiriman barang, serta layanan topup dan tagihan. Kemudahan dan kepercayaan adalah prioritas kami.`}
        />
        <meta
          name="twitter:image"
          content={
            dataBlogs.featured_media ||
            "https://sultanhorse.com/images/hero.jpg"
          }
        />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@SultanHorse" />
        <meta name="twitter:creator" content="@SultanHorse" />
        <meta name="application-name" content="Sultan Horse" />
        <meta name="apple-mobile-web-app-title" content="Sultan Horse" />
        <link
          rel="apple-touch-icon"
          sizes="57x57"
          href="/apple-icon-57x57.png"
        />
        <link
          rel="apple-touch-icon"
          sizes="60x60"
          href="/apple-icon-60x60.png"
        />
        <link
          rel="apple-touch-icon"
          sizes="72x72"
          href="/apple-icon-72x72.png"
        />
        <link
          rel="apple-touch-icon"
          sizes="76x76"
          href="/apple-icon-76x76.png"
        />
        <link
          rel="apple-touch-icon"
          sizes="114x114"
          href="/apple-icon-114x114.png"
        />
        <link
          rel="apple-touch-icon"
          sizes="120x120"
          href="/apple-icon-120x120.png"
        />
        <link
          rel="apple-touch-icon"
          sizes="144x144"
          href="/apple-icon-144x144.png"
        />
        <link
          rel="apple-touch-icon"
          sizes="152x152"
          href="/apple-icon-152x152.png"
        />
        <link
          rel="apple-touch-icon"
          sizes="180x180"
          href="/apple-icon-180x180.png"
        />
        <link
          rel="icon"
          type="image/png"
          sizes="192x192"
          href="/android-icon-192x192.png"
        />
        <link
          rel="icon"
          type="image/png"
          sizes="32x32"
          href="/favicon-32x32.png"
        />
        <link
          rel="icon"
          type="image/png"
          sizes="96x96"
          href="/favicon-96x96.png"
        />
        <link
          rel="icon"
          type="image/png"
          sizes="16x16"
          href="/favicon-16x16.png"
        />
        <link rel="manifest" href="/manifest.json" />
        <meta name="msapplication-TileColor" content="#ffffff" />
        <meta name="msapplication-TileImage" content="/ms-icon-144x144.png" />
        <meta name="theme-color" content="#ffffff" />
        <link rel="icon" href="/favicon.ico" />
        <title>{`${dataBlogs.title?.rendered} - Sultan Horse`}</title>
      </Head>
      <Header />
      <div className="px-4 pt-40 bg-gray-100 b-20 dark:bg-woodsmoke-950 md:px-28 lg:px-60 xl:px-60">
        <div className="p-6 bg-white rounded-xl">
          <h1 className="mb-4 text-lg font-semibold text-black">
            {dataBlogs.title?.rendered}
          </h1>

          <div className="flex items-center justify-center">
            <div
              className="mt-4"
              dangerouslySetInnerHTML={{ __html: dataBlogs.content?.rendered }}
            ></div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default BlogDetail;

export async function getServerSideProps({ res, query, locale }) {
  res.setHeader(
    "Cache-Control",
    "public, s-maxage=15, stale-while-revalidate=59"
  );
  const { slug = "" } = query;

  try {
    let resDapps;

    const apiUrl =
      "https://blog.sultanhorse.com/wp-json/wp/v2/posts?_embed&slug=" + slug;

    try {
      const auditUrl = apiUrl;
      resDapps = await axios.get(auditUrl);
    } catch (error) {
      console.log(error);
      resDapps = { data: [] };
    }

    return {
      props: {
        ...(await serverSideTranslations(locale, ["common"])),
        dataBlogs: resDapps.data[0] || [],
      },
    };
  } catch (error) {
    console.log(error);
    return {
      props: {
        dataBlogs: [],
      },
    };
  }
}
